import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { SelectionModel } from "@angular/cdk/collections";
import { MatDialog } from "@angular/material/dialog";
import { TranslocoService } from "@ngneat/transloco";
import { combineLatest, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ExperienceLevelType, IAccessTable, IAppSettingsWrap, ICRUDRecord, IPlayerProps, ISceneItemPosition, ISchedule, IUser } from "../../../interfaces";
import { actionCRUDRecord, actionSelectedSceneId, actionSelectedSceneTouchId, actionUpdateSceneItem } from "../../../store/actions/user.actions";
import { AccessService, CommonService, ContainerService, LocalStoreService, StoreSelectorsService } from "../../../services";
import { SceneMimeTypes } from "../scene-blocks/mime-constants";
import { IBlockLabelsRecords } from "../scene-blocks/block-constants";
import { Compbaser } from "../../../components/compbaser";
import { DialogCategoryTreeComponent } from "../../../components/dialog-category-tree/dialog-category-tree.component";
import { isSceneButNotSubScene, isSceneEmbedded, isMainTouchScene, preprocessSceneRecord, sceneItemInvalid } from "app/common";
import { debounce } from "utils-decorators";
import { faPlugCircleCheck, faShare, faShareNodes } from "@fortawesome/free-solid-svg-icons";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { StationAddPlayerComponent } from "../../stations/station-add-player/station-add-player.component";
import { TouchLib } from "../touch/touchLib";

const PlayerMimeTypes = [SceneMimeTypes.Player, SceneMimeTypes.Slides];

@Component({
    selector: "app-scene-list-props",
    templateUrl: "./scene-list-props.component.html",
    styleUrls: ["./scene-list-props.component.scss"],
    standalone: false
})
export class SceneListPropsComponent extends Compbaser implements OnInit {
    isMimeMainPlayer: boolean;
    isPlayerAssignable = false;
    isPlayerPublicData = false;
    isScheduledEnabled;
    mimeTypes = [];
    selectedSchedule: string;
    accessKey = "0";
    accessMask: Array<string> = [];
    blockLabelRecords: IBlockLabelsRecords;
    schedules: Array<ISchedule> = [];
    selectionModel: SelectionModel<number>;
    renderScenes: IPlayerProps[] = [];
    category = "";
    categories: Array<string> = [];
    previewWidth = 260;
    coreAppData: IAppSettingsWrap;
    sceneWidth;
    sceneHeight;
    groupsAccessTable$: Observable<IAccessTable>;
    faPlugCircleCheck = faPlugCircleCheck;
    selectedSceneId;

    sceneItems: ISceneItemPosition[] = [];
    previewRatio = 1;
    // nonSelectedSchedule: any;

    readonly experienceLevelType = ExperienceLevelType; // Expose enum to template
    experienceLevel: ExperienceLevelType;

    constructor(
        private storeSelector: StoreSelectorsService,
        private translocoService: TranslocoService,
        private containerService: ContainerService,
        private localStoreService: LocalStoreService,
        private accessService: AccessService,
        private commonService: CommonService,
        private toastr: ToastrService,
        public router: Router,
        public override dialog: MatDialog,
    ) {
        super();
        this.me = "scene-list-props";
        this.blockLabelRecords = this.storeSelector.blockLabels;
        this.groupsAccessTable$ = this.accessService.getGroupsTable("SignStudio Editor", "player_data");
        Object.keys(SceneMimeTypes).forEach((k) => {
            this.mimeTypes.push(k);
        });
        this.cod(
            this.storeSelector.getUserAccessMask().subscribe((v) => {
                this.accessMask = v;
            }),
        );
        this.cod(
            this.storeSelector.getSchedules().subscribe((i_items: ISchedule[]) => {
                this.schedules = i_items;
            }),
        );
        // this.cod(
        //     this.accessService.getGroupsTable('SignStudio Editor', "player_data").subscribe((v) => {
        //         this.accessConfig = v;
        //     })
        // );
        this.cod(
            this.storeSelector.getLocalStoreUpdates().subscribe((updates) => {
                this.isScheduledEnabled = this.localStoreService.getStorageValConfig("scheduledEnabled");
            }),
        );
        this.cod(this.storeSelector.getCoreData().subscribe((i_coreData: IAppSettingsWrap) => (this.coreAppData = i_coreData)));

        this.cod(
            this.storeSelector.getLocalStoreUpdates("ILocalStorageConfig").subscribe((e) => {
                this.experienceLevel = this.localStoreService.getStorageValConfig("experienceLevel"); // Alon
            }),
        );
    }

    @Output() deleting: EventEmitter<any> = new EventEmitter<any>();
    @Output() deselecting: EventEmitter<any> = new EventEmitter<any>();
    @Output() updateSelection: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    set setSelectionModel(i_selectionModel) {
        this.selectionModel = i_selectionModel;
        this.composeSelectedScene();
    }

    ngOnInit() {
        this.cod(
            this.containerService.getCategories().subscribe((i_categories) => {
                this.categories = i_categories ? i_categories : [];
            }),
        );

        // setTimeout(() => {
        //     this.nonSelectedSchedule = {
        //         schedule_name: this.translocoService.translate('general.nonScheduled', {}, this.translocoService.getActiveLang()),
        //         schedule_id: '-1',
        //         active: false
        //     };
        // }, 300);
    }

    composeSelectedScene() {
        this.cod(
            combineLatest([this.selectionModel.changed, this.storeSelector.getScenes()])
                .pipe(
                    map(([selectedScenes, scenes]) => {
                        return scenes.filter((s) => {
                            return selectedScenes.source.selected.findIndex((id) => String(id) === s.Player.$.id) > -1;
                        });
                    }),
                )
                .subscribe((v) => {
                    this.renderScenes = v;
                    this.selectedSceneId = null;
                    if (this.renderScenes.length === 1) {
                        this.category = this.renderScenes[0].Player?.$?.folder;
                        this.accessKey = this.renderScenes[0].Player?.$?.accessKey;
                        this.isMimeMainPlayer =
                            this.renderScenes[0].Player.$?.mimeType === SceneMimeTypes.Player ||
                            this.renderScenes[0].Player.$?.mimeType === SceneMimeTypes.Scene ||
                            this.renderScenes[0].Player.$?.mimeType.length === 0;
                        this.isPlayerAssignable = PlayerMimeTypes.includes(this.renderScenes[0].Player.$?.mimeType) || this.renderScenes[0].Player.$?.mimeType.length === 0;
                        this.isPlayerPublicData = this.renderScenes[0].Player.$?.player_data_public === "1";
                        this.selectedSchedule = this.renderScenes[0].Player?.$?.scheduleId && this.renderScenes[0].Player?.$?.scheduleId !== "-1" ? this.renderScenes[0].Player?.$?.scheduleId : "-1";

                        setTimeout(() => {
                            this.sceneWidth = parseInt(this.renderScenes[0]?.Player?.Data[0]?.Layout[0]?.$.width);
                            this.sceneHeight = parseInt(this.renderScenes[0]?.Player?.Data[0]?.Layout[0]?.$.height);
                            this.selectedSceneId = this.renderScenes[0]?.Player?.$?.id;
                        }, 100);
                    } else if (this.renderScenes.length > 1) {
                        let tempCategory = "";
                        this.renderScenes.forEach((_scene, ind) => {
                            if (ind === 0) {
                                tempCategory = _scene.Player?.$?.folder;
                            } else {
                                if (tempCategory != _scene.Player?.$?.folder) {
                                    tempCategory = "";
                                }
                            }
                        });
                        this.category = tempCategory;
                    }
                }),
        );
    }

    @debounce(333)
    onChangeSceneName(event) {
        const sceneName = event.target.value;
        if (!sceneName) return;
        if (this.renderScenes.length === 0) return;
        this.storeSelector.dispatch(
            actionUpdateSceneItem({
                sceneId: this.renderScenes[0].Player.$.id,
                sceneItemId: this.renderScenes[0].Player.$.id,
                values: [
                    {
                        key: "label",
                        value: sceneName,
                        storePath: "$",
                    },
                ],
                disableCRUD: true,
            }),
        );
        setTimeout(() => {
            this.updateScene(this.renderScenes[0].Player.$.id, this.renderScenes[0]);
        });

        // update scheduler event value with new scene name
        this.commonService.updateScheduleEventValue("scene", [this.renderScenes[0].Player.$.id], sceneName);
    }

    updateTreePath(filterValue: string) {
        this.renderScenes.forEach((_scene) => {
            const sceneId = _scene.Player.$.id;
            this.storeSelector.dispatch(
                actionUpdateSceneItem({
                    sceneId,
                    sceneItemId: sceneId,
                    values: [
                        {
                            key: "folder",
                            value: filterValue,
                            storePath: "$",
                        },
                    ],
                    disableCRUD: true,
                }),
            );

            /** Update scene */
            const saveRecord: ICRUDRecord = {
                studioId: this.localStoreService.getStorageConfig().studioId,
                command: "update",
                primary: "player_data_id",
                table: "player_data",
                body: {
                    tree_path: filterValue,
                },
                id: sceneId,
            };
            this.storeSelector.dispatch(actionCRUDRecord({ saveRecord }));
        });
    }

    changePlayerPublicData(value) {
        const checked = value.checked ? "1" : "0";
        this.storeSelector.dispatch(
            actionUpdateSceneItem({
                sceneId: this.renderScenes[0].Player.$.id,
                sceneItemId: this.renderScenes[0].Player.$.id,
                values: [
                    {
                        key: "player_data_public",
                        value: checked,
                        storePath: "$",
                    },
                ],
                disableCRUD: true,
            }),
        );

        /** save scene */
        const saveRecord: ICRUDRecord = {
            studioId: this.localStoreService.getStorageConfig().studioId,
            command: "update",
            primary: "player_data_id",
            table: "player_data",
            body: {
                player_data_public: checked,
            },
            id: this.renderScenes[0].Player.$.id,
        };
        this.storeSelector.dispatch(actionCRUDRecord({ saveRecord }));
    }

    changeAccessMask(filterValue: string) {
        this.storeSelector.dispatch(
            actionUpdateSceneItem({
                sceneId: this.renderScenes[0].Player.$.id,
                sceneItemId: this.renderScenes[0].Player.$.id,
                values: [
                    {
                        key: "accessKey",
                        value: filterValue,
                        storePath: "$",
                    },
                ],
                disableCRUD: true,
            }),
        );

        /** save scene */
        const saveRecord: ICRUDRecord = {
            studioId: this.localStoreService.getStorageConfig().studioId,
            command: "update",
            primary: "player_data_id",
            table: "player_data",
            body: {
                access_key: filterValue,
            },
            id: this.renderScenes[0].Player.$.id,
        };
        this.storeSelector.dispatch(actionCRUDRecord({ saveRecord }));
    }

    togglePlayerAssignable(v) {
        this.storeSelector.dispatch(
            actionUpdateSceneItem({
                sceneId: this.renderScenes[0].Player.$.id,
                sceneItemId: this.renderScenes[0].Player.$.id,
                values: [
                    {
                        key: "mimeType",
                        value: v.checked === true ? "mainPlayer" : "scene",
                        storePath: "$",
                    },
                ],
                disableCRUD: true,
            }),
        );
        this.updateScene(this.renderScenes[0].Player.$.id, this.renderScenes[0]);
    }

    dropdownSchedulerChanged(v) {
        this.storeSelector.dispatch(
            actionUpdateSceneItem({
                sceneId: this.renderScenes[0].Player.$.id,
                sceneItemId: this.renderScenes[0].Player.$.id,
                values: [
                    {
                        key: "scheduleId",
                        value: v.value,
                        storePath: "$",
                    },
                ],
                disableCRUD: true,
            }),
        );
        this.updateScene(this.renderScenes[0].Player.$.id, this.renderScenes[0]);
    }

    openCategoryTree() {
        this.dialog.open(DialogCategoryTreeComponent, {
            width: "500px",
            data: {
                categories: this.categories,
                treePath: this.category,
                callback: (treePath: string) => {
                    this.updateTreePath(treePath);
                },
            },
        });
    }

    toggleSelection(sceneId) {
        this.selectionModel.toggle(sceneId);
        this.updateSelection.emit(this.selectionModel);
    }

    navigateToScene(scene) {
        if (isSceneEmbedded(scene)) {
            return this.toastr.error(this.translocoService.translate("toast.embeddedScenesNo", {}, this.translocoService.getActiveLang()));
        }
        if (isMainTouchScene(scene)) {
            // Navigate to touch editor (same logic as touch-list-details)
            const firstChildSceneId = TouchLib.getFirstSlideSceneId(scene);
            this.storeSelector.dispatch(actionSelectedSceneId({ id: firstChildSceneId }));
            this.storeSelector.dispatch(actionSelectedSceneTouchId(TouchLib.createSelectedSliderPayload(scene.Player.$.id, scene.Player.$.label, firstChildSceneId)));
            this.router.navigateByUrl(`/editor/touch/scene/${scene.Player.$.id}`);
        } else {
            this.storeSelector.dispatch(actionSelectedSceneId({ id: scene.Player.$.id }));
            this.router.navigate([`/editor/scene/${scene.Player.$.id}`]);
        }
    }

    deleteItems() {
        this.deleting.next(this.selectionModel);
    }

    deselectItems() {
        this.deselecting.next(null);
    }

    private updateScene(sceneId, scene) {
        const saveRecord: ICRUDRecord = preprocessSceneRecord(scene, sceneId, this.localStoreService.getStorageConfig().studioId, "update");
        this.storeSelector.dispatch(actionCRUDRecord({ saveRecord }));
    }

    showAddPlayerModal() {
        StationAddPlayerComponent.createDialog(this.dialog, this.selectedSceneId);
    }

    // Slider-specific methods
    isSliderScene(): boolean {
        return this.renderScenes.length === 1 && isMainTouchScene(this.renderScenes[0]);
    }
}
